import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { bubbleStyles } from '../../data/commonStyles';

type MessageTextWrapperProps = {
  isSingleLine: boolean;
  isUserMessage: boolean;
  shouldBreakWords: boolean;
  direction: 'rtl' | 'ltr';
};

export const MessageTextWrapper = styled.div<MessageTextWrapperProps>`
  color: #000;
  font-weight: 400;
  text-align: ${({ direction }) => (direction === 'ltr' ? 'left' : 'right')};
  letter-spacing: 0.5px;
  word-break: ${({ shouldBreakWords }) => (shouldBreakWords ? 'break-all' : 'normal')};
  overflow-wrap: break-word;
  direction: ${({ direction }) => direction};
  background: ${({ isUserMessage, theme }) => (isUserMessage ? theme.colors.light : '#fff')};
  box-shadow: 0 0 2px 0 #0000001a;
  box-sizing: border-box;

  ${({ theme }) => css`
    @media (${theme.mediaMobile}) {
      line-height: 22px;
      font-size: 16px;
    }

    @media not (${theme.mediaMobile}) {
      line-height: 18px;
      font-size: 14px;
    }
  `}

  hr {
    margin: 20px 0;
    border-top: 1px solid #d2d2d2;
  }

  strong,
  b {
    font-weight: 500;
  }

  strong {
    font-weight: bold;
  }

  .spinner {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-width: 2px;
    border-radius: 50%;
    border-style: solid;
    border-color: #ccc;
    border-bottom-color: transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }

  ul {
    list-style: none;
  }

  li {
    margin-bottom: 20px;

    &:last-of-type {
      button {
        margin-bottom: 13px;
      }
    }
  }

  & > ol,
  & > ul {
    margin: 20px 0;
  }

  ol {
    padding-left: 20px;
    list-style: decimal;

    ul {
      margin: 5px 0;
      padding-left: 17px;

      li {
        margin-bottom: 5px;
      }
    }
  }

  img {
    width: 104px;
    height: 104px;
    overflow: hidden;
    border-radius: 50%;
  }

  a {
    color: #000;
    font-weight: 500;
    text-decoration: none;
  }

  p {
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 10px 0;
  }

  .left {
    h6 {
      margin: 0;
      line-height: 130%;
      font-size: 13px;
      font-weight: 500;
      text-overflow: ellipsis;
      overflow: hidden;
      letter-spacing: 0.13px;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    span {
      display: block;
      margin-top: 5px;
      font-size: 13px;
    }

    a {
      display: inline-block;
      margin-top: 10px;
      color: #000;
      line-height: 119%;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.14px;
      border-bottom: 1px solid #000;
    }
  }

  .right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
    margin-left: 10px;
    height: 87px;

    img {
      display: block;
      max-width: 100%;
    }
  }

  ${({ isUserMessage, theme }) => (isUserMessage ? theme.messageText.user : theme.messageText.ml)};

  ${bubbleStyles};
`;

export const ProcessingTimeWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  font-size: 10px;
  font-weight: 500;
  gap: 10px;
`;

export const ProcessingTime = styled.div`
  padding: 0 4px 2px;
  color: black;
  font-weight: bold;
  border: 1px solid #afafaf;
  border-radius: 4px;
`;
